import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import shortid from 'shortid'
import styled from 'styled-components'
import { statusColor } from '../../helpers/color'

class InformationModal extends React.PureComponent {
  isEmpty = (text) => {
    return text && text !== '' ? text : '-'
  }

  render() {
    const users = get(this.props, 'timesheets.users', [])
    const approve_status = get(this.props, 'timesheetRequest.timesheetRequest.approve_status', [])

    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'open') }
        toggle={ get(this.props, 'toggle') }
      >
        <HeaderForm toggle={ get(this.props, 'toggle') }>
          <HeadLabel>{ `Approver's Remark` }</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form>
                <FormGroup>
                  <Container >
                    { approve_status.map((status) => {
                      const approve = find(users, { _id: status.approver_id })
                      return (
                        <RowRemark key={ shortid() }>
                          <RowContent>
                            <InfoLabel>
                              { approve ? `${get(approve, 'first_name')} ${get(approve, 'last_name')} (${get(approve, 'nick_name')})` : '-'}
                            </InfoLabel>
                          </RowContent>
                          <RowContent>
                            <InfoLabelContent color={ statusColor(status.status) }>
                              <Circle color={ statusColor(status.status) } />
                              { status.status }
                            </InfoLabelContent>
                            <InfoLabelContent>
                              { status.submitted && moment(status.submitted).format('DD/MM/YYYY') }
                            </InfoLabelContent>
                          </RowContent>
                          <RowContent>
                            <InfoLabelContent>
                              { status.remark !== '' ? status.remark : '-' }
                            </InfoLabelContent>
                          </RowContent>
                        </RowRemark>
                      )
                    })
                    }
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter />
      </Modal>
    )
  }
}

export default InformationModal

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const RowContent = styled(Row)`
  width: 100%;
`
const RowRemark = styled(Row)`
  width: 100%;
  margin-bottom: 10px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const InfoLabel = styled(Label)`
  display: flex;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
  margin-bottom:0px !important;
  margin-left: 30px;
  color: ${props => { return props.color ? props.color : 'black' }};
`
const InfoLabelContent = styled(Label)`
  font-family: 'Gotham' !important;
  display: flex;
  font-size: 12px;
  margin-bottom:0px !important;
  margin-left: 30px;
  color: ${props => { return props.color ? props.color : 'black' }};
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-approval/remark-modal.js